/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */

export type TrainWithMeDataEnumsSubscriptionChannel = typeof TrainWithMeDataEnumsSubscriptionChannel[keyof typeof TrainWithMeDataEnumsSubscriptionChannel];


export const TrainWithMeDataEnumsSubscriptionChannel = {
  AppStore: 'AppStore',
  GooglePlay: 'GooglePlay',
  Comp: 'Comp',
  Web: 'Web',
  TestStore: 'TestStore',
} as const;
